import React from 'react';
import Updater from './updater';
import QuotesPage from './QuotesPage';

const QPage = () => {
  return (
    <>
      <QuotesPage/>
      <Updater/>
    </>
  )
}

export default QPage;